import { useState } from 'react';
import { OrganisationPayTypesTab, PAY_TYPES_PANEL_HOST_ID } from '../features/payTypes/OrganisationPayTypesTab';
import './ConfigurationPage.css';

export const PayTypesPage = () => {
  const [panelOpen, setPanelOpen] = useState(false);
  return <div className={`configuration-page${panelOpen ? ' configuration-page--panel-open' : ''}`}>
    <div className="tabbed-item-page__main"><OrganisationPayTypesTab onPanelVisibilityChange={setPanelOpen} /></div>
    <div id={PAY_TYPES_PANEL_HOST_ID} className="configuration-page__detail-host" />
  </div>;
};
